import { TableCell, TableSortLabel } from '@mui/material';

export type SortDirection = 'asc' | 'desc';

export type Comparator<T> = (a: T, b: T) => number;

export const compareNumber = (a: number, b: number) => a - b;

export const compareString = (a: string, b: string) => a.localeCompare(b);

export const compareBoolean = (a: boolean, b: boolean) => Number(a) - Number(b);

export const compareBy = <T, V>(valueOf: (row: T) => V, compare: Comparator<V>): Comparator<T> => {
    return (a, b) => compare(valueOf(a), valueOf(b));
};

export const invert =
    <T,>(cmp: Comparator<T>): Comparator<T> =>
    (a, b) =>
        -cmp(a, b);

export const stableSort = <T,>(rows: readonly T[], cmp: Comparator<T>): T[] => {
    return [...rows]
        .map((row, idx) => ({ row, idx }))
        .sort((a, b) => {
            const res = cmp(a.row, b.row);
            return res !== 0 ? res : a.idx - b.idx;
        })
        .map((x) => x.row);
};

export const SortableHeaderCell = (props: {
    label: string;
    sortKey: string;
    activeKey: string | null;
    direction: SortDirection;
    onChange: (key: string) => void;
    align?: 'left' | 'right' | 'center';
}) => {
    const { label, sortKey, activeKey, direction, onChange, align } = props;
    const active = activeKey === sortKey;

    return (
        <TableCell sortDirection={active ? direction : false} align={align}>
            <TableSortLabel
                active={active}
                direction={active ? direction : 'asc'}
                onClick={() => onChange(sortKey)}
            >
                {label}
            </TableSortLabel>
        </TableCell>
    );
};
